/**
 * EventFrame stays portrait even when the device rotates. Camera preview and
 * captured files follow that 9:16 lean instead of flipping to landscape.
 */
export const PORTRAIT_ASPECT = 9 / 16

/**
 * Center-crop a frame to `aspect` after digital zoom. `object-fit: cover` in the
 * 9:16 viewfinder uses the same window, so the saved take matches what they composed.
 */
export function coverCrop(width, height, { zoom = 1, aspect = PORTRAIT_ASPECT } = {}) {
  const srcW = Math.max(1, Number(width) || 1)
  const srcH = Math.max(1, Number(height) || 1)
  const z = Math.max(1, Number(zoom) || 1)
  const target = Number(aspect) > 0 ? aspect : PORTRAIT_ASPECT

  let sw = srcW / z
  let sh = srcH / z
  const srcAspect = sw / sh
  if (srcAspect > target) sw = sh * target
  else if (srcAspect < target) sh = sw / target

  return {
    sx: (srcW - sw) / 2,
    sy: (srcH - sh) / 2,
    sw,
    sh
  }
}
